import {Component} from '@angular/core';

@Component({
    selector: 'kan-data-admin',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanDataAdmin {
    public selectedTab: number;

    constructor() {

    }

    ngOnInit(): void {
        this.selectedTab = 0;
    }

    public tabChanged(index: number): void {
        this.selectedTab = index;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/admin/component.ts